module.exports = __webpack_public_path__ + "static/media/new-year-sc.a5ea778c.jpg";